import {
  ADD_EXTRA_DATA,
  DELETE_EXTRA_DATA_FIELD,
  UPDATE_EXTRA_DATA_FIELD,
  IMPORT_EXTRA_DATA,
  EDITTING_POLICY,
} from './constants'

export const importExtraData = (extraData) => {
  return {
    type: IMPORT_EXTRA_DATA,
    extraData
  }
}


export const edittingPolicyChanged = (editting) => {
  return {
    type: EDITTING_POLICY,
    editting
  }
}


export const addExtraData = (key, value) => {
  return {
    type: ADD_EXTRA_DATA,
    key, value
  }
}

/*
* isKey => indicates whether we are editting key-name or value-name
*/
export const updateExtraData = (id, inputValue, isKey) => {
  return {
    type: UPDATE_EXTRA_DATA_FIELD,
    id, inputValue, isKey
  }
}

export const deleteExtraData = (id) => {
  return {
    type: DELETE_EXTRA_DATA_FIELD,
    id
  }
}



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Policy/actions.js